import React, { Fragment, useRef, useState } from 'react'
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Dialog, Transition } from '@headlessui/react'

const verifyFileType = (filePath) => {
  const fileExtension = filePath.split('.').pop().toLowerCase();
  if (fileExtension === 'pdf') {
    return 'PDF';
  } else if (['jpg', 'jpeg', 'png'].includes(fileExtension)) {
    return 'Image';
  } else {
    return 'Unknown';
  }
}

function FileViewer(props) {
  const { url, setOpen, open } = props;
  const cancelButtonRef = useRef(null);
  const docs = [
    { uri: url, fileType: 'pdf' } // Remote file
  ];
  const fileType = verifyFileType(url)

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
          >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>


          <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enterTo="opacity-100 translate-y-0 sm:scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                      <Dialog.Panel className={`file-viewer-modal relative transform overflow-hidden rounded-lg bg-white pt-2 px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-5xl h-10 sm:p-6 ${fileType === "Image" && "image-viewer"}`}>
                        <div class="flex items-center justify-between mb-2 md:mb-2 border-b rounded-t dark:border-gray-600">
                            <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
                                Preview file
                            </h3>
                            <button onClick={() => setOpen(false)} type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="default-modal">
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                </svg>
                                <span class="sr-only">Close modal</span>
                            </button>
                        </div>
                        {
                            fileType === "Image" ? (
                            <div>
                                <img src={url}/>
                            </div>
                            ) :
                            fileType === "PDF" ?
                            <iframe allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" src={url} className='w-full max-w-full'/> :
                            ""
                        }
                        
                      </Dialog.Panel>
                  </Transition.Child>
              </div>
          </div>
      </Dialog>
    </Transition.Root>
  )
}

export default FileViewer